import { tickerItems } from "@/mocks/home";

export default function TopTicker() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="w-full bg-foreground-950 text-background-100">
      <div className="mx-auto flex h-9 max-w-shell items-center gap-4 px-4 md:px-6">
        <span className="flex shrink-0 items-center gap-2">
          <span className="relative flex h-2 w-2 items-center justify-center">
            <span className="absolute h-2 w-2 rounded-full bg-primary-400 animate-hl-pulse" />
            <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
          </span>
          <span className="text-[11px] md:text-xs font-label tracking-wide text-background-100/90">
            实时更新
          </span>
        </span>

        <span className="hidden h-4 w-px shrink-0 bg-background-100/20 md:block" />

        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max items-center gap-8 animate-hl-marquee">
            {loop.map((item, index) => (
              <span
                key={`${item}-${index}`}
                className="flex shrink-0 items-center gap-2 text-[11px] md:text-xs text-background-100/70 font-label"
              >
                <i className="ri-flashlight-line text-primary-400" />
                {item}
              </span>
            ))}
          </div>
        </div>

        <span className="hidden shrink-0 items-center gap-1.5 text-[11px] md:text-xs font-label text-background-100/70 md:flex">
          <i className="ri-download-2-line text-primary-400" />
          下载入口已开放
        </span>
      </div>
    </div>
  );
}